// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"114":"1dc2a046","161":"976f3ebd","239":"e7a2ff17","241":"63367d08","355":"76ce2ac9","396":"8aab547b","455":"89f053e2","673":"8706ea6a","715":"767c05ac","722":"c4662f89","857":"44e4468d","882":"b3559811","889":"05631115","977":"a723575a"}[chunkId] + ".chunk.js";
};